@import '../../scss/mixin';

.synthesis {
  @include btn();
}
